export const aboutMe: string = `
Hi I am Joe, but most people call me Photo Joe. I have covered all kinds of events with photography from barrel racing with horses to rally cars.
I thoroughly enjoy the different challenges and environments these racing series offer. Just last year I was featured in Porsche 356 Magazine for my coverage of the Waumandee Time Trials.

Outside of photography I am a father of two children that are constantly looking to explore new things. During the week I work as a software engineer designing mobile
applications with a focus on user experience. When I want to get away from the office life I am out hiking, riding or adventuring somewhere exciting.

Let's connect! I'm always open to discussing potential projects or coverage at your next event!
`